module.exports = "/_next/static/images/d67f92c76cb213b80de06c8c94098c6f-nobureaucracy@0.5x.png.webp";